// extracted by mini-css-extract-plugin
export default {"topic":"postHeader-module__topic___4ffvm","topRow":"postHeader-module__topRow___skaIE","date":"postHeader-module__date___mWm7I","header":"postHeader-module__header___tSRj5"};